export default __webpack_public_path__ + "static/media/SubmitNotifyImg.35dfe284.svg";